import React from 'react';
import { rwColors } from '@/styles/colors';

interface BaseSliderProps {
  value: number;
  min: number;
  max: number;
  step?: number;
  label1?: React.ReactNode;
  label2?: React.ReactNode;
  onChange: (value: number) => void;
  className?: string;
  vertical?: boolean;
  trackColor?: string;
  thumbColor?: string;
  fillColor?: string;
}

export const BaseSlider: React.FC<BaseSliderProps> = ({
  value,
  min,
  max,
  step = 1,
  label1,
  label2,
  onChange,
  className = '',
  vertical = false,
  trackColor = rwColors['light-gray'],
  thumbColor = rwColors.main,
  fillColor = rwColors.sub,
}) => {
  // 進行率を計算
  const progress = ((value - min) / (max - min)) * 100;
  // 安全化（NaN防止・0〜100に制限）
  const safeProgress = Number.isFinite(progress)
    ? Math.max(0, Math.min(100, progress))
    : 0;

  if (vertical) {
    return (
      <div className={`flex flex-col items-center gap-2 ${className}`}>
        {label1}
        <div className="relative flex h-32 w-4 items-center justify-center">
          {/* 背景トラック */}
          <div
            className="absolute h-full w-1 rounded-full"
            style={{ backgroundColor: trackColor }}
          />
          {/* 進行部分 */}
          <div
            className="absolute bottom-0 w-1 rounded-full"
            style={{ height: `${safeProgress}%`, backgroundColor: fillColor }}
          />
          {/* つまみ */}
          <div
            className="pointer-events-none absolute size-4 rounded-full border-2 border-gray-400 shadow-sm"
            style={{
              bottom: `${safeProgress}%`,
              transform: 'translateY(50%)',
              backgroundColor: thumbColor,
            }}
          />
          {/* 実際のinput要素 */}
          <input
            type="range"
            min={min}
            max={max}
            step={step}
            value={value}
            onChange={(e) => onChange(Number(e.target.value))}
            className="absolute inset-0 h-32 w-4 cursor-pointer appearance-none bg-transparent opacity-0 [-webkit-appearance:slider-vertical] [writing-mode:bt-lr]"
          />
        </div>
        {label2}
        {/* <span className="text-xs text-gray-600">{value.toFixed(1)}</span> */}
      </div>
    );
  }

  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      <div className="flex items-center justify-between">
        {label1}
        <span className="text-muted-foreground text-sm">{value}</span>
      </div>
      <div className="relative h-2 w-full">
        {/* 背景トラック */}
        <div
          className="absolute inset-0 rounded-lg"
          style={{ backgroundColor: trackColor }}
        />
        {/* 進行部分 */}
        <div
          className="absolute inset-y-0 left-0 rounded-lg"
          style={{ width: `${safeProgress}%`, backgroundColor: fillColor }}
        />
        {/* 実際のinput要素 */}
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={(e) => onChange(Number(e.target.value))}
          className="absolute inset-0 h-2 w-full cursor-pointer appearance-none bg-transparent"
        />
      </div>
      {label2}
    </div>
  );
};
